import React from 'react';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../../../firebase/interfaces';
import moment from 'moment';
import { STANDARD_DATE } from 'utilities/dateHelper';
import { Card } from '../Card';

const PatientSkip = ({ lastUpdated }: { lastUpdated?: string }) => {
  const { user } = useAuth();
  const isProvider = user?.role === Roles.PROVIDER;

  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.COMPLETE_MY_VISIT_SUMMARY_MODAL,
  });

  return (
    <Card
      title={locale?.summaryDetails}
      titleClassName="flex text-h4 text-btn-black font-semibold"
      showSeparator
      defaultExpanded
      subtitleClassName="!text-base font-medium max-desktop:mt-2.5"
      subtitle={moment(lastUpdated).format(`[Summary date:] ${STANDARD_DATE}`)}
    >
      <div className="w-full h-full text-center py-48 px-32">
        <div className="text-lg font-semibold mb-1">
          {isProvider
            ? locale?.patientSkippedTitle
            : 'You missed this appointment'}
        </div>
        <div className="font-medium text-med-gray-3">
          {isProvider
            ? locale?.patientSkippedDescription
            : 'You missed this appointment. According to Decode.me Privacy Policy, no refund is available'}
        </div>
      </div>
    </Card>
  );
};

export default PatientSkip;
